import pix from './pix'

export default {
  namespaced: true,
  modules: {
    pix,
  },
  getters: {},
  state: {},
  mutations: {},
  actions: {},
}
